import { formatDate } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Component, Inject, LOCALE_ID, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { DataExportService } from "src/app/_services/dataExportService";
import { InvoiceService } from "src/app/_services/invoice.service";
import { PosService } from "src/app/_services/posService";

@Component({
  selector: "app-credit-notes",
  templateUrl: "./credit-notes.component.html",
  styleUrls: ["./credit-notes.component.scss"],
})
export class CreditNotesComponent implements OnInit {
  displayName: any;
  isCondensed: boolean = false;
  currentLayout = {
    isCondensed: true,
  };
  searchTerm: string = "";
  creditNote = [];
  allCreditNotes = [];
  responseData: any;
  isError: any;
  isEmpty = false;
  loading = true;

  page = 1;
  pageSize = 10;
  collectionSize: any;
  notes: any;
  tempDataset = [];
  sessionExpired = false;
  errorMsg = "";
  selectedOption = true;
  filterBy: any = "barcodeRegex";
  canSubmitNonPo = false;
  canSubmitLogistics = false;
  vendorData: any;
  tableData: any;
  gstExist: boolean;
  checkproperty: string;

  creditNotes;

  constructor(
    private router: Router,
    private http: HttpClient,
    private authService: AuthService,
    private invoiceService: InvoiceService,
    private exportService: DataExportService,
    private posService: PosService,
    @Inject(LOCALE_ID) public locale: string
  ) {}

  exportToExcel() {
    const date = new Date();

    const fileName = (this.displayName = localStorage.getItem("vendorCode")) + "_Invoices_Table_" + formatDate(date, "dd_MM_yyyy_h_mm_a", this.locale);

    if (this.selectedOption === false) {
      this.tableData = this.creditNotes;
    } else {
      this.tableData = this.creditNotes;
    }

    const cols = [
      {
        name: "CN / DN No",
        colKey: "doc_number",
      },
      {
        name: "Doc Type",
        colKey: "doc_type",
      },
      {
        name: "Barcode No.",
        colKey: "barcode",
      },
      {
        name: "PO No",
        colKey: "poNo",
      },
      {
        name: "Credit Note Amount",
        colKey: "doc_amount",
      },
      {
        name: "Currency",
        colKey: "po_currency",
      },
      {
        name: "Current Status",
        colKey: "status",
      },
    ];

    this.exportService.exportToExcel(this.tableData, cols, fileName);
  }

  accountLogout() {
    localStorage.clear();
    this.router.navigateByUrl("/");
    // const userData = {
    //     session: { sessionId: localStorage.getItem("eippSession") },
    // };
    // this.authService.logOut(userData).subscribe(
    //     (res) => {
    //         const responseData: any = res;
    //         if (responseData.status === "ok") {
    //             localStorage.clear();
    //             this.router.navigateByUrl("/");
    //         }
    //     },
    //     (error) => {
    //         console.log(error);
    //     }
    // );
  }

  refreshNotes() {
    let sortedNotes = this.creditNotes.sort((a, b) => (a.creation_date_sys > b.creation_date_sys ? 1 : -1));

    sortedNotes.forEach((e) => {
      if (this.checkObjectKeyExist(e, "rejections", "rej1") === undefined) {
        Object.assign(e, { rejection1: false });
      } else {
        Object.assign(e, { rejection1: true });
      }

      if (this.checkObjectKeyExist(e, "rejections", "rej2") === undefined) {
        Object.assign(e, { rejection2: false });
      } else {
        Object.assign(e, { rejection2: true });
      }

      if (this.checkObjectKeyExist(e, "gst_reconciled") === undefined) {
        Object.assign(e, { gst_exist: false });
      } else {
        Object.assign(e, { gst_exist: true });
      }
    });

    this.notes = sortedNotes.map((po, i) => ({ id: i + 1, ...po })).slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }

  orderBy(prop: string) {
    return this.notes.sort((a, b) => (a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1));
  }

  onFilter(option: any) {
    this.filterBy = option.target.value;
    this.selectedOption = true;
  }

  onSearch(event: KeyboardEvent) {
    console.log("onSearch");
    
    this.searchTerm = (event.target as HTMLInputElement).value;
    this.fetchNotes();
    // if (this.searchTerm !== "") {
    //   if (this.filterBy === "doc_number") {
    //     this.notes = this.creditNotes.filter((data) => data.docNo.toLowerCase().includes(this.searchTerm.toLowerCase()));
    //   } else if (this.filterBy === "poNo") {
    //     this.notes = this.creditNotes.filter((data) => data.poNo.toString().toLowerCase().includes(this.searchTerm.toLowerCase()));
    //   } else if (this.filterBy === "barcode") {
    //     this.notes = this.creditNotes.filter((data) => data.barcode.toLowerCase().includes(this.searchTerm.toLowerCase()));
    //   } else if (this.filterBy === "status") {
    //     this.notes = this.creditNotes.filter((data) => data.status.toLowerCase().includes(this.searchTerm.toLowerCase()));
    //   }
    // } else {
    //   this.notes = this.creditNotes;
    // }
  }

  generalSearch(event: KeyboardEvent) {
    this.searchTerm = (event.target as HTMLInputElement).value;

    if (this.searchTerm !== "") {
      this.notes = this.creditNotes.filter(
        (data) =>
          data.credit_note_number.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          data.poNo.toString().toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          data.barcode.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          data.status.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    } else {
      this.notes = this.creditNotes;
    }
  }

  fetchNotes() {
    this.loading = true;
    const userData = {
      sortConfig: {
        field: "updateTime",
        order: "desc",
      },
      pageSize: 50,
      pageNo: 1,
      filters: [
        {
          key: "docType",
          value: "CN,DN",
        },
        {
          key: "supplierCodesToRestrict",
          value: localStorage.getItem("vendorCode"),
        },
      ],
      sellercode: this.authService.getSellerCode(),
      isExport: false,
      linkFilters: [],
      isAP: true,
    };
    console.log(this.filterBy, "filterBy");
    if (this.searchTerm !== "") {
      const trimmed = this.searchTerm.trim();
      const filterValue =
        this.filterBy === "statusRegex" ? this.uppercaseStatusForQuery(trimmed) : trimmed;
      userData.filters.push({
        key: this.filterBy,
        value: filterValue,
      });
    }
    this.posService.fetchCNDN(userData).subscribe(
      (res) => {
        this.responseData = res;
        console.log(this.responseData, "responseData");

        if (this.responseData.code === 200) {
          this.creditNotes = this.responseData.data.list;
          console.log(this.creditNotes, "creditNotes");
          
          this.collectionSize = this.responseData.data.noOfRecords;
          this.refreshNotes();

          if (this.collectionSize === 0) {
            this.isEmpty = true;
          } else {
            this.isEmpty = false;
          }
          this.loading = false;
        } else {
          this.loading = false;
          this.isEmpty = true;
        }
      },
      (error) => {
        this.loading = false;
        if (error.status === 401 || error.status === 403) {
          this.sessionExpired = true;
          this.errorMsg = error.error.msg;
        }
      }
    );
  }

  ngOnInit(): void {
    this.displayName = localStorage.getItem("displayName");
    this.fetchNotes();
  }

  checkObjectKeyExist(obj, ...args) {
    return args.reduce((obj, level) => obj && obj[level], obj);
  }

  /** Uppercases every character of the status search text for the Current Status API query. */
  private uppercaseStatusForQuery(value: string): string {
    if (!value) {
      return value;
    }
    return value.trim().toUpperCase();
  }
}
